<template>
  <div class="common-banner" :style="{ height: height + 'px' }">
    <img class="banner-img"  :src="src || require('@/assets/images/home-banner.png')" alt="" />
    <div class="banner-nav" v-if="navList.length">
      <div class="banner-nav-item" v-for="item in navList" :key="item.path" @click="handleClick(item)">
        {{ item.name }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'common-banner',
  props: {
    src: {
      type: String,
      default: require('@/assets/images/home-banner.png')
    },
    navList: {
      type: Array,
      default: () => []
    },
    height: {
      type: Number,
      default: 640
    }
  },
  methods: {
    handleClick(item) {
      this.$emit('navClick', item)
    }
  }
}
</script>
<style lang="scss" scoped>
.common-banner {
  width: 100%;
  height: 640px;
  position: relative;
  .banner-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .banner-nav {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0);
    display: flex;
    width: 1320px;
    .banner-nav-item{
      flex: 1;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 56px;
      font-size: 24px;
      cursor: pointer;
      background: #3A6A4A99;
      color: #CFCFC1;
      transition: all 0.3s ;
      transform: translateY(0);
      &:hover {
        color: #F4E8B6;
        background: #5EA877;
        transform: translateY(-8px);
      }
    }
  }
}
</style>
